import {FITH2GameConfig} from "../configs/FITH2GameConfig";
import {gsap} from "gsap";

export class FITH2SymbolAnimation extends PIXI.Container{
    private _dimmer: PIXI.Sprite;
    constructor() {
        super();
        this.name = "SymbolAnimation";
        this.position=FITH2GameConfig.reelAreaPos;
        this.creatDimmer();
    }

    private getReelAreaWidth(): number {
        return (FITH2GameConfig.symbolWidth * FITH2GameConfig.reelsNum) + 20;
    }

    private getReelAreaHeight(): number {
        return FITH2GameConfig.symbolHeight * 6;
    }

    private creatDimmer(): void {
        this._dimmer = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._dimmer.name = "dimmer";
        this._dimmer.width = this.getReelAreaWidth();
        this._dimmer.height = this.getReelAreaHeight();
        this._dimmer.position.set(-FITH2GameConfig.symbolWidth * 0.5, 0);
        this._dimmer.tint = 0x000000;
        this._dimmer.alpha = 0.7;
        this._dimmer.visible = false;
        this.addChild(this._dimmer);
    }
    public addDimmer(): gsap.core.Timeline {
        this._dimmer.alpha = 0;
        this._dimmer.visible = true;
        return new gsap.core.Timeline().add(() => {
        }).add(gsap.to(this._dimmer, 0.4, {alpha: 0.4}));
    }

    public removeDimmer(): gsap.core.Timeline {
        return new gsap.core.Timeline().to(this._dimmer, 0.2, {alpha: 0}).add(() => {
            this._dimmer.visible = false;
        });
    }
}